import { StateShape } from "src/models/initialState"
import { useSelector, TypedUseSelectorHook, shallowEqual } from "react-redux"

export const useTypedSelector: TypedUseSelectorHook<StateShape> = useSelector
export const useShallowEqualTypedSelector = (selector: (s: StateShape) => any) =>
  useTypedSelector(selector, shallowEqual)
